/**
 * @en The `Keyboard` class contains constants representing the most commonly used keys for controlling a game.
 * @zh `Keyboard` 类的属性是一些常数，这些常数表示控制游戏时最常用的键。
 */
export class Keyboard {
    /** 
     * @en The constant associated with the key code value (48) for the 0 key.
     * @zh 与 0 的键控代码值(48) 关联的常数。
     */
    static NUMBER_0: number = 48;
    /** 
     * @en The constant associated with the key code value (49) for the 1 key.
     * @zh 与 1 的键控代码值 (49) 关联的常数。
     */
    static NUMBER_1: number = 49;
    /** 
     * @en The constant associated with the key code value (50) for the 2 key.
     * @zh 与 2 的键控代码值 (50) 关联的常数。
     */
    static NUMBER_2: number = 50;
    /** 
     * @en The constant associated with the key code value (51) for the 3 key.
     * @zh 与 3 的键控代码值 (51) 关联的常数。
     */
    static NUMBER_3: number = 51;
    /** 
     * @en The constant associated with the key code value (52) for the 4 key.
     * @zh 与 4 的键控代码值 (52) 关联的常数。
     */
    static NUMBER_4: number = 52;
    /** 
     * @en The constant associated with the key code value (53) for the 5 key.
     * @zh 与 5 的键控代码值 (53) 关联的常数。
     */
    static NUMBER_5: number = 53;
    /** 
     * @en The constant associated with the key code value (54) for the 6 key.
     * @zh 与 6 的键控代码值 (54) 关联的常数。
     */
    static NUMBER_6: number = 54;
    /** 
     * @en The constant associated with the key code value (55) for the 7 key.
     * @zh 与 7 的键控代码值 (55) 关联的常数。
     */
    static NUMBER_7: number = 55;
    /** 
     * @en The constant associated with the key code value (56) for the 8 key.
     * @zh 与 8 的键控代码值 (56) 关联的常数。
     */
    static NUMBER_8: number = 56;
    /** 
     * @en The constant associated with the key code value (57) for the 9 key.
     * @zh 与 9 的键控代码值 (57) 关联的常数。
     */
    static NUMBER_9: number = 57;

    /** 
     * @en The constant associated with the key code value (65) for the A key.
     * @zh 与 A 键的键控代码值 (65) 关联的常数。
     */
    static A: number = 65;
    /** 
     * @en The constant associated with the key code value (66) for the B key.
     * @zh 与 B 键的键控代码值 (66) 关联的常数。
     */
    static B: number = 66;
    /** 
     * @en The constant associated with the key code value (67) for the C key.
     * @zh 与 C 键的键控代码值 (67) 关联的常数。
     */
    static C: number = 67;
    /** 
     * @en The constant associated with the key code value (68) for the D key.
     * @zh 与 D 键的键控代码值 (68) 关联的常数。
     */
    static D: number = 68;
    /** 
     * @en The constant associated with the key code value (69) for the E key.
     * @zh 与 E 键的键控代码值 (69) 关联的常数。
     */
    static E: number = 69;
    /** 
     * @en The constant associated with the key code value (70) for the F key.
     * @zh 与 F 键的键控代码值 (70) 关联的常数。
     */
    static F: number = 70;
    /** 
     * @en The constant associated with the key code value (71) for the G key.
     * @zh 与 G 键的键控代码值 (71) 关联的常数。
     */
    static G: number = 71;
    /** 
     * @en The constant associated with the key code value (72) for the H key.
     * @zh 与 H 键的键控代码值 (72) 关联的常数。
     */
    static H: number = 72;
    /** 
     * @en The constant associated with the key code value (73) for the I key.
     * @zh 与 I 键的键控代码值 (73) 关联的常数。
     */
    static I: number = 73;
    /** 
     * @en The constant associated with the key code value (74) for the J key.
     * @zh 与 J 键的键控代码值 (74) 关联的常数。
     */
    static J: number = 74;
    /** 
     * @en The constant associated with the key code value (75) for the K key.
     * @zh 与 K 键的键控代码值 (75) 关联的常数。
     */
    static K: number = 75;
    /** 
     * @en The constant associated with the key code value (76) for the L key.
     * @zh 与 L 键的键控代码值 (76) 关联的常数。
     */
    static L: number = 76;
    /** 
     * @en The constant associated with the key code value (77) for the M key.
     * @zh 与 M 键的键控代码值 (77) 关联的常数。
     */
    static M: number = 77;
    /** 
     * @en The constant associated with the key code value (78) for the N key.
     * @zh 与 N 键的键控代码值 (78) 关联的常数。
     */
    static N: number = 78;
    /** 
     * @en The constant associated with the key code value (79) for the O key.
     * @zh 与 O 键的键控代码值 (79) 关联的常数。
     */
    static O: number = 79;
    /** 
     * @en The constant associated with the key code value (80) for the P key.
     * @zh 与 P 键的键控代码值 (80) 关联的常数。
     */
    static P: number = 80;
    /** 
     * @en The constant associated with the key code value (81) for the Q key.
     * @zh 与 Q 键的键控代码值 (81) 关联的常数。
     */
    static Q: number = 81;
    /** 
     * @en The constant associated with the key code value (82) for the R key.
     * @zh 与 R 键的键控代码值 (82) 关联的常数。
     */
    static R: number = 82;
    /** 
     * @en The constant associated with the key code value (83) for the S key.
     * @zh 与 S 键的键控代码值 (83) 关联的常数。
     */
    static S: number = 83;
    /** 
     * @en The constant associated with the key code value (84) for the T key.
     * @zh 与 T 键的键控代码值 (84) 关联的常数。
     */
    static T: number = 84;
    /** 
     * @en The constant associated with the key code value (85) for the U key.
     * @zh 与 U 键的键控代码值 (85) 关联的常数。
     */
    static U: number = 85;
    /** 
     * @en The constant associated with the key code value (86) for the V key.
     * @zh 与 V 键的键控代码值 (86) 关联的常数。
     */
    static V: number = 86;
    /** 
     * @en The constant associated with the key code value (87) for the W key.
     * @zh 与 W 键的键控代码值 (87) 关联的常数。
     */
    static W: number = 87;
    /** 
     * @en The constant associated with the key code value (88) for the X key.
     * @zh 与 X 键的键控代码值 (88) 关联的常数。
     */
    static X: number = 88;
    /** 
     * @en The constant associated with the key code value (89) for the Y key.
     * @zh 与 Y 键的键控代码值 (89) 关联的常数。
     */
    static Y: number = 89;
    /** 
     * @en The constant associated with the key code value (90) for the Z key.
     * @zh 与 Z 键的键控代码值 (90) 关联的常数。
     */
    static Z: number = 90;

    /** 
     * @en The constant associated with the key code value (112) for the F1 key.
     * @zh 与 F1 的键控代码值 (112) 关联的常数。
     */
    static F1: number = 112;
    /** 
     * @en The constant associated with the key code value (113) for the F2 key.
     * @zh 与 F2 的键控代码值 (113) 关联的常数。
     */
    static F2: number = 113;
    /** 
     * @en The constant associated with the key code value (114) for the F3 key.
     * @zh 与 F3 的键控代码值 (114) 关联的常数。
     */
    static F3: number = 114;
    /** 
     * @en The constant associated with the key code value (115) for the F4 key.
     * @zh 与 F4 的键控代码值 (115) 关联的常数。
     */
    static F4: number = 115;
    /** 
     * @en The constant associated with the key code value (116) for the F5 key.
     * @zh 与 F5 的键控代码值 (116) 关联的常数。
     */
    static F5: number = 116;
    /** 
     * @en The constant associated with the key code value (117) for the F6 key.
     * @zh 与 F6 的键控代码值 (117) 关联的常数。
     */
    static F6: number = 117;
    /** 
     * @en The constant associated with the key code value (118) for the F7 key.
     * @zh 与 F7 的键控代码值 (118) 关联的常数。
     */
    static F7: number = 118;
    /** 
     * @en The constant associated with the key code value (119) for the F8 key.
     * @zh 与 F8 的键控代码值 (119) 关联的常数。
     */
    static F8: number = 119;
    /** 
     * @en The constant associated with the key code value (120) for the F9 key.
     * @zh 与 F9 的键控代码值 (120) 关联的常数。
     */
    static F9: number = 120;
    /** 
     * @en The constant associated with the key code value (121) for the F10 key.
     * @zh 与 F10 的键控代码值 (121) 关联的常数。
     */
    static F10: number = 121;
    /** 
     * @en The constant associated with the key code value (122) for the F11 key.
     * @zh 与 F11 的键控代码值 (122) 关联的常数。
     */
    static F11: number = 122;
    /** 
     * @en The constant associated with the key code value (123) for the F12 key.
     * @zh 与 F12 的键控代码值 (123) 关联的常数。
     */
    static F12: number = 123;
    /** 
     * @en The constant associated with the key code value (124) for the F13 key.
     * @zh 与 F13 的键控代码值 (124) 关联的常数。
     */
    static F13: number = 124;
    /** 
     * @en The constant associated with the key code value (125) for the F14 key.
     * @zh 与 F14 的键控代码值 (125) 关联的常数。
     */
    static F14: number = 125;
    /** 
     * @en The constant associated with the key code value (126) for the F15 key.
     * @zh 与 F15 的键控代码值 (126) 关联的常数。
     */
    static F15: number = 126;

    /** 
     * @en The constant associated with the pseudo key code (21) for the numeric keypad.
     * @zh 与数字键盘的伪键控代码 (21) 关联的常数。
     */
    static NUMPAD: number = 21;
    /** 
     * @en The constant associated with the key code value (96) for the number 0 on the numeric keypad.
     * @zh 与数字键盘上的数字 0 的键控代码值 (96) 关联的常数。
     */
    static NUMPAD_0: number = 96;
    /** 
     * @en The constant associated with the key code value (97) for the number 1 on the numeric keypad.
     * @zh 与数字键盘上的数字 1 的键控代码值 (97) 关联的常数。
     */
    static NUMPAD_1: number = 97;
    /** 
     * @en The constant associated with the key code value (98) for the number 2 on the numeric keypad.
     * @zh 与数字键盘上的数字 2 的键控代码值 (98) 关联的常数。
     */
    static NUMPAD_2: number = 98;
    /** 
     * @en The constant associated with the key code value (99) for the number 3 on the numeric keypad.
     * @zh 与数字键盘上的数字 3 的键控代码值 (99) 关联的常数。
     */
    static NUMPAD_3: number = 99;
    /** 
     * @en The constant associated with the key code value (100) for the number 4 on the numeric keypad.
     * @zh 与数字键盘上的数字 4 的键控代码值 (100) 关联的常数。
     */
    static NUMPAD_4: number = 100;
    /** 
     * @en The constant associated with the key code value (101) for the number 5 on the numeric keypad.
     * @zh 与数字键盘上的数字 5 的键控代码值 (101) 关联的常数。
     */
    static NUMPAD_5: number = 101;
    /** 
     * @en The constant associated with the key code value (102) for the number 6 on the numeric keypad.
     * @zh 与数字键盘上的数字 6 的键控代码值 (102) 关联的常数。
     */
    static NUMPAD_6: number = 102;
    /** 
     * @en The constant associated with the key code value (103) for the number 7 on the numeric keypad.
     * @zh 与数字键盘上的数字 7 的键控代码值 (103) 关联的常数。
     */
    static NUMPAD_7: number = 103;
    /** 
     * @en The constant associated with the key code value (104) for the number 8 on the numeric keypad.
     * @zh 与数字键盘上的数字 8 的键控代码值 (104) 关联的常数。
     */
    static NUMPAD_8: number = 104;
    /** 
     * @en The constant associated with the key code value (105) for the number 9 on the numeric keypad.
     * @zh 与数字键盘上的数字 9 的键控代码值 (105) 关联的常数。
     */
    static NUMPAD_9: number = 105;

    /** 
     * @en The constant associated with the key code value (107) for the plus sign (+) on the numeric keypad.
     * @zh 与数字键盘上的加号 (+) 的键控代码值 (107) 关联的常数。
     */
    static NUMPAD_ADD: number = 107;
    /** 
     * @en The constant associated with the key code value (110) for the decimal point (.) on the numeric keypad.
     * @zh 与数字键盘上的小数点 (.) 的键控代码值 (110) 关联的常数。
     */
    static NUMPAD_DECIMAL: number = 110;
    /** 
     * @en The constant associated with the key code value (111) for the division sign (/) on the numeric keypad.
     * @zh 与数字键盘上的除号 (/) 的键控代码值 (111) 关联的常数。
     */
    static NUMPAD_DIVIDE: number = 111;
    /** 
     * @en The constant associated with the key code value (108) for the Enter key on the numeric keypad.
     * @zh 与数字键盘上的 Enter 的键控代码值 (108) 关联的常数。
     */
    static NUMPAD_ENTER: number = 108;
    /** 
     * @en The constant associated with the key code value (106) for the multiplication sign (*) on the numeric keypad.
     * @zh 与数字键盘上的乘号 (*) 的键控代码值 (106) 关联的常数。
     */
    static NUMPAD_MULTIPLY: number = 106;
    /** 
     * @en The constant associated with the key code value (109) for the minus sign (-) on the numeric keypad.
     * @zh 与数字键盘上的减号 (-) 的键控代码值 (109) 关联的常数。
     */
    static NUMPAD_SUBTRACT: number = 109;
    /** 
     * @en The constant associated with the key code value (186) for the semicolon (;) key.
     * @zh 与 ; 键的键控代码值 (186) 关联的常数。
     */
    static SEMICOLON: number = 186;
    /** 
     * @en The constant associated with the key code value (187) for the equal sign (=) key.
     * @zh 与 = 键的键控代码值 (187) 关联的常数。
     */
    static EQUAL: number = 187;
    /** 
     * @en The constant associated with the key code value (188) for the comma (,) key.
     * @zh 与 F15 的键控代码值 (188) 关联的常数。
     */
    static COMMA: number = 188;
    /** 
     * @en The constant associated with the key code value (189) for the minus (-) key.
     * @zh 与 - 键的键控代码值 (189) 关联的常数。
     */
    static MINUS: number = 189;
    /** 
     * @en The constant associated with the key code value (190) for the period (.) key.
     * @zh 与 . 键的键控代码值 (190) 关联的常数。
     */
    static PERIOD: number = 190;
    /** 
     * @en The constant associated with the key code value (191) for the forward slash (/) key.
     * @zh 与 / 键的键控代码值 (191) 关联的常数。
     */
    static SLASH: number = 191;
    /** 
     * @en The constant associated with the key code value (192) for the backquote (`) key.
     * @zh 与 ` 键的键控代码值 (192) 关联的常数。
     */
    static BACKQUOTE: number = 192;
    /** 
     * @en The constant associated with the key code value (219) for the left bracket ([) key.
     * @zh 与 [ 键的键控代码值 (219) 关联的常数。
     */
    static LEFTBRACKET: number = 219;
    /** 
     * @en The constant associated with the key code value (220) for the backslash (\) key.
     * @zh 与 \ 键的键控代码值 (220) 关联的常数。
     */
    static BACKSLASH: number = 220;
    /** 
     * @en The constant associated with the key code value (221) for the right bracket (]) key.
     * @zh 与 ] 键的键控代码值 (221) 关联的常数。
     */
    static RIGHTBRACKET: number = 221;
    /** 
     * @en The constant associated with the key code value (222) for the single quote (') key.
     * @zh 与 ' 键的键控代码值 (222) 关联的常数。
     */
    static QUOTE: number = 222;
    /** 
     * @en The constant associated with the key code value (18) for the Alternate (Option) key.
     * @zh 与 Alternate (Option) 键的键控代码值 (18) 关联的常数。
     */
    static ALTERNATE: number = 18;
    /** 
     * @en The constant associated with the key code value (8) for the Backspace key.
     * @zh 与 Backspace 的键控代码值 (8) 关联的常数。
     */
    static BACKSPACE: number = 8;
    /** 
     * @en The constant associated with the key code value (20) for the Caps Lock key.
     * @zh 与 Caps Lock 的键控代码值 (20) 关联的常数。
     */
    static CAPS_LOCK: number = 20;
    /** 
     * @en The constant associated with the key code value (15) for the Mac Command key.
     * @zh 与 Mac 命令键 (15) 关联的常数。
     */
    static COMMAND: number = 15;
    /** 
     * @en The constant associated with the key code value (17) for the Ctrl key.
     * @zh 与 Ctrl 的键控代码值 (17) 关联的常数。
     */
    static CONTROL: number = 17;
    /** 
     * @en The constant associated with the key code value (46) for the Delete key.
     * @zh 与 Delete 的键控代码值 (46) 关联的常数。
     */
    static DELETE: number = 46;
    /** 
     * @en The constant associated with the key code value (13) for the Enter key.
     * @zh 与 Enter 的键控代码值 (13) 关联的常数。
     */
    static ENTER: number = 13;
    /** 
     * @en The constant associated with the key code value (27) for the Esc key.
     * @zh 与 Esc 的键控代码值 (27) 关联的常数。
     */
    static ESCAPE: number = 27;
    /** 
     * @en The constant associated with the key code value (33) for the Page Up key.
     * @zh 与 Page Up 的键控代码值 (33) 关联的常数。
     */
    static PAGE_UP: number = 33;
    /** 
     * @en The constant associated with the key code value (34) for the Page Down key.
     * @zh 与 Page Down 的键控代码值 (34) 关联的常数。
     */
    static PAGE_DOWN: number = 34;
    /** 
     * @en The constant associated with the key code value (35) for the End key.
     * @zh 与 End 的键控代码值 (35) 关联的常数。
     */
    static END: number = 35;
    /** 
     * @en The constant associated with the key code value (36) for the Home key.
     * @zh 与 Home 的键控代码值 (36) 关联的常数。
     */
    static HOME: number = 36;
    /** 
     * @en The constant associated with the key code value (37) for the Left Arrow key.
     * @zh 与向左箭头键的键控代码值 (37) 关联的常数。
     */
    static LEFT: number = 37;
    /** 
     * @en The constant associated with the key code value (38) for the Up Arrow key.
     * @zh 与向上箭头键的键控代码值 (38) 关联的常数。
     */
    static UP: number = 38;
    /** 
     * @en The constant associated with the key code value (39) for the Right Arrow key.
     * @zh 与向右箭头键的键控代码值 (39) 关联的常数。
     */
    static RIGHT: number = 39;
    /** 
     * @en The constant associated with the key code value (40) for the Down Arrow key.
     * @zh 与向下箭头键的键控代码值 (40) 关联的常数。
     */
    static DOWN: number = 40;
    /** 
     * @en The constant associated with the key code value (16) for the Shift key.
     * @zh 与 Shift 的键控代码值 (16) 关联的常数。
     */
    static SHIFT: number = 16;
    /** 
     * @en The constant associated with the key code value (32) for the Spacebar.
     * @zh 与空格键的键控代码值 (32) 关联的常数。
     */
    static SPACE: number = 32;
    /** 
     * @en The constant associated with the key code value (9) for the Tab key.
     * @zh 与 Tab 的键控代码值 (9) 关联的常数。
     */
    static TAB: number = 9;
    /** 
     * @en The constant associated with the key code value (45) for the Insert key.
     * @zh 与 Insert 的键控代码值 (45) 关联的常数。
     */
    static INSERT: number = 45;
}


